/**
 * Curated destination image references sourced from Unsplash.
 * Keys are normalized city slugs (lowercase, spaces replaced with hyphens).
 */
export type DestinationImageMap = Record<string, string>;

export const CURATED_DESTINATION_IMAGES: DestinationImageMap = {
  'lisbon': 'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=400&h=400&fit=crop',
  'porto': 'https://images.unsplash.com/photo-1505764706515-aa95265c5abc?w=400&h=400&fit=crop',
  'paris': 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1600&q=80',
  'london': 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=1600&q=80',
  'rome': 'https://images.unsplash.com/photo-1529260830199-42c24126f198?w=400&h=400&fit=crop',
  'venice': 'https://images.unsplash.com/photo-1505769771379-7ef73a8984b0?w=400&h=400&fit=crop',
  'florence': 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=400&h=400&fit=crop', // Duomo & Arno
  'milan': 'https://images.unsplash.com/photo-1505840726984-9e6f43b81d01?w=400&h=400&fit=crop',
  'barcelona': 'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=400&h=400&fit=crop',
  'madrid': 'https://images.unsplash.com/photo-1505761671935-60b3a7427bad?w=400&h=400&fit=crop',
  'valencia': 'https://images.unsplash.com/photo-1503343891161-2b39e747a5cc?w=400&h=400&fit=crop',
  'amsterdam': 'https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=400&h=400&fit=crop',
  'berlin': 'https://images.unsplash.com/photo-1587330979470-3585acb8d859?w=400&h=400&fit=crop',
  'munich': 'https://images.unsplash.com/photo-1505761683-1a8e2d1e9647?w=400&h=400&fit=crop', // Marienplatz
  'prague': 'https://images.unsplash.com/photo-1541849546-216549ae216d?w=400&h=400&fit=crop',
  'vienna': 'https://images.unsplash.com/photo-1516550164664-5af3c7b7e863?w=400&h=400&fit=crop',
  'budapest': 'https://images.unsplash.com/photo-1505765050516-f72dcac9c60b?w=400&h=400&fit=crop', // Parliament on the Danube
  'athens': 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=400&h=400&fit=crop',
  'santorini': 'https://images.unsplash.com/photo-1506176399970-2477790d9018?w=400&h=400&fit=crop',
  'mykonos': 'https://images.unsplash.com/photo-1508672019048-805c876b67e2?w=400&h=400&fit=crop',
  'dubai': 'https://images.unsplash.com/photo-1505028106030-e07ea1bd80c3?w=400&h=400&fit=crop', // Burj Khalifa skyline
  'abu-dhabi': 'https://images.unsplash.com/photo-1529429617124-aee1f1650a5c?w=400&h=400&fit=crop', // Sheikh Zayed Grand Mosque
  'tokyo': 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=1600&q=80',
  'kyoto': 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=1600&q=80',
  'osaka': 'https://images.unsplash.com/photo-1503899036084-c55cdd92da26?auto=format&fit=crop&w=1600&q=80',
  // Lotte World Tower skyline, Seoul — Unsplash photo 1546874177-9e664107314e (user-provided)
  'seoul': 'https://images.unsplash.com/photo-1546874177-9e664107314e?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'singapore': 'https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=400&h=400&fit=crop',
  'bangkok': 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=400&h=400&fit=crop',
  'bali': 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=1600&q=80',
  'sydney': 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=400&fit=crop',
  'melbourne': 'https://images.unsplash.com/photo-1543616991-2d8c937a8a0d?w=400&h=400&fit=crop',
  'auckland': 'https://images.unsplash.com/photo-1540541338287-41700207dee6?w=400&h=400&fit=crop', // Sky Tower skyline
  'queenstown': 'https://images.unsplash.com/photo-1502786129293-79981df4e689?w=400&h=400&fit=crop', // Lake Wakatipu
  'honolulu': 'https://images.unsplash.com/photo-1505739775205-6b10a0a1f5c7?w=400&h=400&fit=crop', // Waikiki & Diamond Head
  'new-york': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=400&h=400&fit=crop',
  'new-york-city': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?auto=format&fit=crop&w=1600&q=80', // Manhattan skyline
  'los-angeles': 'https://images.unsplash.com/photo-1534190239940-9ba11d8f5da4?w=400&h=400&fit=crop',
  'san-francisco': 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=400&h=400&fit=crop',
  'seattle': 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=400&h=400&fit=crop', // Space Needle view
  'miami': 'https://images.unsplash.com/photo-1514214246283-d427a95c5d2f?w=400&h=400&fit=crop',
  'chicago': 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=1600&q=80',
  'washington-dc': 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&h=400&fit=crop', // Lincoln Memorial/Reflecting Pool
  'orlando': 'https://images.unsplash.com/photo-1511732351661-977974b72b23?auto=format&fit=crop&w=1600&q=80',
  'mexico': 'https://images.unsplash.com/photo-1503437313881-503a91226402?w=400&h=400&fit=crop', // Teotihuacan pyramids
  // Toronto skyline / CN Tower — replaced May 2026 after photo-1531326119258 began returning 404 from CDN
  'toronto': 'https://images.unsplash.com/photo-1741804691345-1d429849b6df?auto=format&fit=crop&w=1600&q=80',
  'vancouver': 'https://images.unsplash.com/photo-1559511260-66a654ae982a?w=400&h=400&fit=crop',
  'montreal': 'https://images.unsplash.com/photo-1503435824048-a799a3a84bf7?w=400&h=400&fit=crop', // Montreal skyline
  'mexico-city': 'https://images.unsplash.com/photo-1518105779142-d9df8a5b6d90?auto=format&fit=crop&w=1600&q=80', // Mexico City skyline
  'oaxaca': 'https://images.unsplash.com/photo-1482938289607-e9573fc25ebb?w=400&h=400&fit=crop',
  'australia': 'https://images.unsplash.com/photo-1506976785307-8732e854ad89?w=400&h=400&fit=crop', // Sydney Opera House
  'rio-de-janeiro': 'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=400&h=400&fit=crop',
  'sao-paulo': 'https://images.unsplash.com/photo-1506806732259-39c2d0268443?w=400&h=400&fit=crop',
  'buenos-aires': 'https://images.unsplash.com/photo-1552832230-019b8f0b5b62?w=400&h=400&fit=crop',
  'santiago': 'https://images.unsplash.com/photo-1526402462921-410d1ce81141?w=400&h=400&fit=crop', // Santiago skyline & Andes
  'saint-petersburg': 'https://images.unsplash.com/photo-1505761771557-1ffccd736a3f?w=400&h=400&fit=crop', // Church of the Savior on Spilled Blood / canals
  'cape-town': 'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=400&h=400&fit=crop',
  'iceland': 'https://images.unsplash.com/photo-1476610182048-b716b8518aae?auto=format&fit=crop&w=1600&q=80',
  'lagos': 'https://images.unsplash.com/photo-1545239351-1141bd82e8a6?w=400&h=400&fit=crop', // Lagos skyline
  'nairobi': 'https://images.unsplash.com/photo-1508615070457-7baeba4003ab?w=400&h=400&fit=crop', // Nairobi skyline with park
  'marrakech': 'https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=400&h=400&fit=crop',
  'morocco': 'https://images.unsplash.com/photo-1500534318412-3a4d96f7736b?auto=format&fit=crop&w=1600&q=80&sat=-10', // Sahara dunes / Morocco
  'cairo': 'https://images.unsplash.com/photo-1572252009286-268acec5ca0a?w=400&h=400&fit=crop',
  'istanbul': 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=400&h=400&fit=crop',
  'tel-aviv': 'https://images.unsplash.com/photo-1505731138473-10b5b032fede?w=400&h=400&fit=crop', // Tel Aviv beachfront
  'amman': 'https://images.unsplash.com/photo-1588692048711-5d7ff57c91f5?w=400&h=400&fit=crop', // Amman Citadel
  'doha': 'https://images.unsplash.com/photo-1523731407965-2430cd12f5e4?w=400&h=400&fit=crop', // Doha skyline
  'uganda-&-rwanda': 'https://images.unsplash.com/photo-1471115853179-bb1d604434e0?w=1200&h=600&fit=crop', // Virunga hills
  'uganda': 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=1200&h=600&fit=crop', // Safari landscape
  'kigali': 'https://images.unsplash.com/photo-1526481280695-3c469c2f815b?w=1200&h=600&fit=crop', // Kigali cityscape
  'mumbai': 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=400&h=400&fit=crop',
  'delhi': 'https://images.unsplash.com/photo-1582979512210-99b6a53386f9?w=400&h=400&fit=crop',
  'jaipur': 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=400&h=400&fit=crop',
  'kolkata': 'https://images.unsplash.com/photo-1524499982521-1ffd58dd89ea?w=400&h=400&fit=crop',
  'hong-kong': 'https://images.unsplash.com/photo-1538598849262-281adf58d6e9?auto=format&fit=crop&w=1600&q=80', // Hong Kong skyline
  'shanghai': 'https://images.unsplash.com/photo-1587371420090-1e8f4c1d0a3a?w=400&h=400&fit=crop',
  'beijing': 'https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=400&h=400&fit=crop',
  'taipei': 'https://images.unsplash.com/photo-1505762842762-1520b489e09b?w=400&h=400&fit=crop', // Taipei 101 skyline
  'manila': 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=400&h=400&fit=crop',
  'ho-chi-minh': 'https://images.unsplash.com/photo-1491557345352-5929e343eb89?w=400&h=400&fit=crop',
  'phuket': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=400&fit=crop', // Phuket beach
  'quebec-city': 'https://images.unsplash.com/photo-1448907503123-67254d59ca4a?w=400&h=400&fit=crop', // Old Quebec skyline
  'canadian-rockies': 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1600&q=80&sat=-15',
  'bora-bora': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1600&q=80&sat=-40',
  'colombia': 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1600&q=80&sat=-55',
  // Country-level fallbacks for landmark relevance
  'taiwan': 'https://images.unsplash.com/photo-1505762842762-1520b489e09b?auto=format&fit=crop&w=1600&q=80', // Taipei 101
  'philippines': 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1600&q=80', // Limestone/island vibes
  // Country-wide fallbacks when only a country slug resolves (parity with landmarkImages regional fallback)
  'canada': 'https://images.unsplash.com/photo-1741804691345-1d429849b6df?auto=format&fit=crop&w=1600&q=80', // CN Tower / Toronto
  'peru': 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1600&q=80&sat=-25', // Machu Picchu
  'mauritius': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1600&q=80&sat=-45', // Lagoon sunset
  'costa-rica': 'https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=1600&q=80', // Arenal volcano
  'tanzania': 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1600&q=80&sat=-35', // Safari landscape
  'greenland': 'https://images.unsplash.com/photo-1500534314602-1c8a5f90c98e?auto=format&fit=crop&w=1600&q=80', // Arctic landscape
  'new-zealand': 'https://images.unsplash.com/photo-1500534318412-3a4d96f7736b?auto=format&fit=crop&w=1600&q=80&sat=-20', // Southern Alps
  'deer-valley-park-city': 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1600&q=80&sat=-60', // Mountain peaks
  'north-dakota': 'https://images.unsplash.com/photo-1500534318412-3a4d96f7736b?auto=format&fit=crop&w=1600&q=80&sat=-30', // Badlands-style landscape
  'vietnam': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1600&q=80&sat=-50', // Karst islands
  'spain': 'https://images.unsplash.com/photo-1528909514045-2fa4ac7a08ba?auto=format&fit=crop&w=1600&q=80', // Barcelona/Spain vibe
  'italy': 'https://images.unsplash.com/photo-1529260830199-42c24126f198?auto=format&fit=crop&w=1600&q=80', // Rome/Colosseum
  'egypt': 'https://images.unsplash.com/photo-1572252009286-268acec5ca0a?auto=format&fit=crop&w=1600&q=80', // Cairo/pyramids
};

/** Trailing segments often joined into `city` without commas (slug misses curated city key). */
const CURATED_GEO_TAIL_SLUGS: Set<string> = new Set([
  'canada',
  'usa',
  'us',
  'uk',
  'england',
  'scotland',
  'wales',
  'ontario',
  'on',
  'quebec',
  'qc',
  'british-columbia',
  'bc',
  'alberta',
  'ab',
  'manitoba',
  'mb',
  'nova-scotia',
  'ns',
  'saskatchewan',
  'sk',
]);

export const DESTINATION_IMAGE_ALIASES: Record<string, string> = {
  'lisboa': 'lisbon',
  'porto-portugal': 'porto',
  'nyc': 'new-york',
  'new-york-new-york': 'new-york',
  'lax': 'los-angeles',
  'la': 'los-angeles',
  'sf': 'san-francisco',
  'san-fran': 'san-francisco',
  'washington': 'washington-dc',
  'district-of-columbia': 'washington-dc',
  'saint-petersburg': 'saint-petersburg',
  'saint-petersburg-russia': 'saint-petersburg',
  'saint-petersburg-florida': 'saint-petersburg',
  'ho-chi-minh-city': 'ho-chi-minh',
  'saigon': 'ho-chi-minh',
  'phuket': 'phuket',
  // Additional aliases to stabilize template slugs
  'australia-road-trip': 'australia',
  'australia-alps-coast': 'australia',
  'orlando-florida': 'orlando',
  'mauritius-island': 'mauritius',
  'mexico-10-day': 'mexico',
  'mexico-city-10-day': 'mexico-city',
  'taiwan-island': 'taiwan',
  'hong-kong-sar': 'hong-kong',
  'greenland-island': 'greenland',
  'costa-rica-adventure': 'costa-rica',
  'tanzania-safari': 'tanzania',
  'new-york-city-solo': 'new-york-city',
  'italy-highlights': 'italy',
  'vietnam-escape': 'vietnam',
  'morocco-highlights': 'morocco',
  'philippines-islands': 'philippines',
  'egypt-pyramids': 'egypt',
  'new-zealand-alps': 'new-zealand',
  'peru-andes': 'peru',
  'spain-highlights': 'spain',
  'quebec-city-canada': 'quebec-city',
  'deer-valley-and-park-city': 'deer-valley-park-city',
  'park-city': 'deer-valley-park-city',
  'chicago-illinois': 'chicago',
  'toronto-canada': 'toronto',
  'toronto-ontario': 'toronto',
  'toronto-on': 'toronto',
  'greater-toronto-area': 'toronto',
  'yyz': 'toronto',
  'toronto-pearson': 'toronto',
};

const stripTrailingGeoSegments = (slug: string): string | null => {
  const segments = slug.split('-').filter(Boolean);
  while (segments.length > 1) {
    const tail = segments[segments.length - 1]!;
    if (!CURATED_GEO_TAIL_SLUGS.has(tail)) {
      break;
    }
    segments.pop();
  }
  const joined = segments.join('-');
  return joined !== slug ? joined : null;
};

export const getCuratedDestinationImage = (citySlug: string): string | null => {
  if (!citySlug) return null;

  let cursor: string | null = citySlug;
  const seen = new Set<string>();
  while (cursor && !seen.has(cursor)) {
    seen.add(cursor);

    if (CURATED_DESTINATION_IMAGES[cursor]) {
      return CURATED_DESTINATION_IMAGES[cursor];
    }

    const aliasTarget = DESTINATION_IMAGE_ALIASES[cursor];
    if (aliasTarget && CURATED_DESTINATION_IMAGES[aliasTarget]) {
      return CURATED_DESTINATION_IMAGES[aliasTarget];
    }

    const stripped = stripTrailingGeoSegments(cursor);
    cursor = stripped;
  }
  return null;
};

export const CURATED_DESTINATION_IMAGE_COUNT = Object.keys(CURATED_DESTINATION_IMAGES).length;


